'use client';

import type { PostType } from '@prisma/client';
import { Carousel } from '@/components/carousel';
import PostCard from '@/components/post-card';
import { api } from '@/server/callers/client';

interface PostCarouselProps {
  postType?: PostType;
}

export default function PostCarousel({ postType }: PostCarouselProps) {
  const { data: posts } = api.posts.infinity.useQuery({
    pagination: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      type: postType,
    },
    sorting: {
      column: 'createdAt',
      direction: 'desc',
    },
  });

  return (
    <Carousel
      className="w-full"
      options={{ loop: true, align: 'center' }}
      autoplay={true}
      autoplayOptions={{
        delay: 2000,
      }}
    >
      {posts?.data.map((post) => (
        <PostCard key={post.id} post={post} className="mx-2" />
      ))}
    </Carousel>
  );
}
